module.exports = "/assets/about/hero.png?LDt3dC1";